import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { MenuService } from 'src/app/shared/services/menu.service';

@Component({
  selector: 'app-menu-item',
  templateUrl: './menu-item.component.html',
  styleUrls: ['./menu-item.component.scss']
})
export class MenuItemComponent {
  @Input() item: any;
  @Input() itemParent: any;
  @Input() rolesUsuario = [];
  @Input() nivel = 0;
  @Output() cerrarMenu = new EventEmitter();
  constructor(private menuService: MenuService) {
  }


  validateAccessMenu(item: any) {

    if (item?.rol == "" || !item?.rol) {
      return item?.visible ?? false;
    }

    if (this.rolesUsuario.some(elemento => item?.rol.includes(elemento))) {
      return true;
    }

    return false;

  }
  itemSeleccionadoReporte2() {

    this.cerrarMenu.emit();

    const dataEnviar = {
      reporte: this.item?.rep,
      opcionMenu: this.itemParent?.nombre,
      opcionSubMenu: this.item.nombre
    }

    this.menuService.dataEventEmit.emit(dataEnviar);
    this.menuService.setLocalstorage('dataMenu', dataEnviar);
    const id = this.itemParent?.id;
    console.log(id);


    const dropdown = document.getElementById('dropdown-menu-' + id);
    dropdown.classList.remove('show');
    const dropdownNav = document.getElementById('dropdown-menu-nav' + id);
    dropdownNav.classList.remove('show');

  }

  cerrarMenuEvt() {
    this.cerrarMenu.emit();
  }
  itemSeleccionadoReporte() {
    this.cerrarMenu.emit();
    const dataEnviar = {
      reporte: this.item?.rep,
      opcionMenu: this.itemParent?.nombre,
      opcionSubMenu: this.item.nombre
    }
    this.menuService.dataEventEmit.emit(dataEnviar);
    this.menuService.setLocalstorage('dataMenu', dataEnviar);
    const id = this.itemParent?.id;

    const dropdown = document.getElementById('dropdown-menu-' + id);
    dropdown.classList.remove('show');
    const dropdownNav = document.getElementById('dropdown-menu-nav' + id);
    dropdownNav.classList.remove('show');
  }


  returnClassList(item: any) {
    return 'dropdown has-megamenu-menu-govco';
    if (item?.megaMenu === true) {
      return item?.megaMenu === true ? 'dropdown has-megamenu-menu-govco' : '';
    }
    else {
      return item?.children?.length > 0 ? 'dropdown' : '';
    }
  }
}
